import { createStore, combineReducers, applyMiddleware } from "redux";
import { createLogger } from "redux-logger";
import { thunk } from "redux-thunk";
import userReducer from "../header/reducers/userReducer";
import locationReducer from "../order-management/left-filter/location/reducers/locationReducer";
import setLocationReducer from "../order-management/left-filter/location/reducers/setLocationReducer.1";
import providerReducer from "../load-build/orders/reducers/providerReducer";
import setProviderReducer from "../load-build/orders/reducers/setProviderReducer";
import applyFilterReducer from "../order-management/left-filter/reducer/applyFilterReducer";
import httpStatusReducer from "../header/reducers/httpStatusReducer";
import triggerLoadBuildReducer from "../load-build/orders/reducers/triggerLoadBuildReducer";
import loadBuildValidatorReducer from "../load-build/orders/reducers/loadBuildValidatorReducer";
import triggerLoadBuildAvisReducer from "../avis/orders/reducers/triggerLoadBuildAvisReducer";
import avisLoadBuildValidatorReducer from "../avis/orders/reducers/avisLoadBuildValidatorReducer";
import setSpinnerStateReducer from "../formControl/reducers/setSpinnerStateReducer";

const rootReducer = combineReducers({
  locations: locationReducer,
  setLocation: setLocationReducer,
  selectedLocation: applyFilterReducer,
  getUser: userReducer,
  getProviderList: providerReducer,
  setProvider: setProviderReducer,
  selectedProvider: applyFilterReducer,
  httpStatus: httpStatusReducer,
  triggerLoadBuild: triggerLoadBuildReducer,
  loadBuildValidator: loadBuildValidatorReducer,
  triggerLoadBuildAvis : triggerLoadBuildAvisReducer,
  avisLoadBuildValidator : avisLoadBuildValidatorReducer,
  spinnerState : setSpinnerStateReducer
});

const logger = createLogger();
let middleware = [];
if (process.env.REACT_APP_API_ENV === "prod") {
  middleware = [...middleware, thunk];
} else {
  middleware = [...middleware, thunk, logger];
}

const store = createStore(rootReducer, applyMiddleware(...middleware));

export default store;
